  import shopifyCart from '../services/shopify-cart'

class CartItem extends HTMLElement {
  constructor() {
    super()

    const selectedElement = this
    const quantityPlusElement = this.querySelector('.quantity__button--plus')
    const quantityMinusElement = this.querySelector('.quantity__button--minus')
    const removeCartItemButton = this.querySelector('.js-remove-item')

    /**
     * Handle quantity button plus.
     */
    if (quantityPlusElement) {
      quantityPlusElement.addEventListener('click', async (event) => {
        event.preventDefault()

        const target = event.currentTarget
        const parentElement = target.parentElement
        const line = parentElement ? parentElement.dataset.index : null
        const currentQuantity = parentElement ? parentElement.dataset.quantity : null

        if (line && currentQuantity) {
          const newQuantity = Number(currentQuantity) + 1

          await shopifyCart.updateQuantity(Number(line), newQuantity, selectedElement)
        }
      })
    }

    /**
     * Handle quantity button minus.
     */
    if (quantityMinusElement) {
      quantityMinusElement.addEventListener('click', async (event) => {
        event.preventDefault()

        const target = event.currentTarget
        const parentElement = target.parentElement
        const line = parentElement ? parentElement.dataset.index : null
        const currentQuantity = parentElement ? parentElement.dataset.quantity : null

        if (line && currentQuantity) {
          const newQuantity = Number(currentQuantity) - 1

          await shopifyCart.updateQuantity(Number(line), newQuantity, selectedElement)
        }
      })
    }

    /**
     * Handle remove cart item button.
     */
    if (removeCartItemButton) {
      removeCartItemButton.addEventListener('click', async (event) => {
        event.preventDefault()
        const line = removeCartItemButton.dataset.index
        await shopifyCart.removeByLine(Number(line), selectedElement)
      })
    }
  }
}

// Check if element is defined, if not define it..
if (customElements.get('cart-item') === undefined) {
  customElements.define('cart-item', CartItem)
}

export { CartItem }
